import { render, staticRenderFns } from "./Dishes.vue?vue&type=template&id=5d0ba14f&scoped=true"
import script from "./Dishes.vue?vue&type=script&lang=ts"
export * from "./Dishes.vue?vue&type=script&lang=ts"
import style0 from "./Dishes.vue?vue&type=style&index=0&id=5d0ba14f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ba14f",
  null
  
)

export default component.exports